module.exports = "/assets/data/a576494138d6999012f46be594899ac3-E17.data.json";